import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Ag-Grid

import { AgGridModule } from 'ag-grid-angular/main';
import { MgridComponent } from './mgrid-main/mgrid-main.component';
export class MgridModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    HttpClientModule,
    AgGridModule.withComponents([])
  ],
  declarations: [MgridComponent],
  providers: [],
  exports: [
    MgridComponent,
    AgGridModule
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MgridModule_tsickle_Closure_declarations() {
/** @type {?} */
MgridModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MgridModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
